import './index.scss'
export const Nav = ({ currentStep, goToStep }) => {
  return (
    <>
      <div className='wizard-progress' style={{ marginTop: 0 }}>
        <div className={`step ${currentStep === 1 ? 'in-progress' : currentStep > 1 ? 'complete' : ''}`}>
          <div style={{ paddingLeft: '37%', marginBottom: 70 }}><div className='text' onClick={() => goToStep(1)}>1</div></div>
          <div className='node' />
        </div>
        <div className={`step ${currentStep === 2 ? 'in-progress' : currentStep > 2 ? 'complete' : ''}`}>
          <div style={{ paddingLeft: '37%', marginBottom: 70 }}><div className='text' onClick={() => currentStep > 2 && goToStep(2)}>2</div></div>
          <div className='node' />
        </div>
        <div className={`step ${currentStep === 3 ? 'in-progress' : currentStep > 3 ? 'complete' : ''}`}>
          <div style={{ paddingLeft: '37%', marginBottom: 70 }}><div className='text' onClick={() => currentStep > 3 && goToStep(3)}>3</div></div>
          <div className='node' />
        </div>
        <div className={`step ${currentStep === 4 ? 'in-progress' : currentStep > 4 ? 'complete' : ''}`}>
          <div style={{ paddingLeft: '37%', marginBottom: 70 }}><div className='text' onClick={() => currentStep > 4 && goToStep(4)}>4</div></div>
          <div className='node' />
        </div>
        <div className={`step ${currentStep === 5 ? 'in-progress' : currentStep > 5 ? 'complete' : ''}`}>
          <div style={{ paddingLeft: '37%', marginBottom: 70 }}><div className='text' onClick={() => currentStep > 5 && goToStep(5)}>5</div></div>
          <div className='node' />
        </div>
        <div className={`step ${currentStep === 6 ? 'in-progress' : currentStep > 6 ? 'complete' : ''}`}>
          <div style={{ paddingLeft: '37%', marginBottom: 70 }}><div className='text'>Fine</div></div>
          <div className='node' />
        </div>
      </div>
    </>
  )
}
